import { rootStore } from "../mobx/store"
import strings from "../lang/strings"
import { string } from "./common"
import { RESULT_CODE } from "../config/const"

const apiBuyDataByPoint = (context, result, successCallback, options) => {
    context.post('data/buy_data_point', { dat_id: result.dat_id, ...options },
        response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            successCallback?.();
        },
        true,
        err => {
            setTimeout(() => { context.showAlert(err.msg) }, 500)
        }
    )
}

const buyDataByPoint = (context, price, result, successCallback, options={}) => {
    context.showPointUse(result.mb_nick, price, () => {
        const mb_point = rootStore.getMe.mb_point
        if (Number(mb_point) < Number(price)) {
            context.showPointLack(1, price, () => {
                context.showPointPay()
            })
            return
        }
        apiBuyDataByPoint(context, result, successCallback, options);
    })
}

const buyBettingData = (context, result, props, successCallback) => {
    const price = result.dat_po * 2;
    buyDataByPoint(context, price, result, successCallback, {betting : 1});
}

const tryNormalBuy = (context, result, props, successCallback) => {
    const price = result.dat_po;
    context.post('data/bj_ticket_cnt', { mb_id: result.mb_id },
        response => {
            let ticket = response.readable_cnt
            const ticketBuyable = ticket > 0;
            if (ticketBuyable) {
                const ticketCnt =  1;
                context.showConfirm(string.Format(strings.ask_buy_bj, ticketCnt), (val) => {
                    if (!val) return
                    context.post('data/buy_data', { dat_id: result.dat_id }, () => { successCallback?.() },
                        true,
                        err => {
                            buyDataByPoint(context, price, result, successCallback);
                        })
                })
            } else {
                buyDataByPoint(context, price, result, successCallback);
            }
        },
        false,
        err => {
            if (err.result !== RESULT_CODE.TOKEN_EXPIRED)
                setTimeout(() => { context.showAlert(err.msg) }, 500)
        }
    )
}

const requestBjDataBuy = (context, result, props, successCallback) => {
    if (!rootStore.isSignedIn) {
        props.history.push('/login')
        return
    }

    if (result.is_my_data == 1) {
        successCallback?.()
        return;
    }
    
    if (result.is_readable == 0) {
        context.showAlert(strings.data_disabled)
        return
    }


    if (result.is_purchased == 0) {
        if (result.is_free == 1) {
            apiBuyDataByPoint(context,result, successCallback, {free : 1});
            return;
        }

        const price = result.dat_po;
        if (result.dat_is_betting == 1) {
            context.showBuyOption(price, price*2, (option) => {
                if (option == 'normal') {
                    tryNormalBuy(context, result, props, successCallback);
                } else if (option == 'new') {
                    buyBettingData(context, result, props, successCallback);
                }
            });
            return;
        }
        tryNormalBuy(context, result, props, successCallback);
        return
    }
    successCallback?.()
}

export { requestBjDataBuy };